// Autogenerated file
export const universalTransferDocumentModesEnum = {
    Single: "Single",
    Period: "Period",
};
export const universalTransferDocumentModes = [
    { label: "По заявке", value: "Single" },
    { label: "По периоду", value: "Period" },
];
